import "../App.css";
import {
  tutorial6Binary1,
  tutorialButtonNextPage,
  tutorialButtonPreviousPage,
  tutorialButtonStartLevel,
  tutorialTitle
} from "../strings";

function Tutorial6Binary({ finishTutorial, page, handleNext, handlePrevious }) {

  const maxPages = 1; // Note that the first page has index 0. This means maxPages-1 is the last page.

  return (
    <div>
      <div className="tutorial-title">
        {tutorialTitle}
      </div>
      <div className="tutorial-body">
        {page === 0 && 
          <div>
            {tutorial6Binary1}
          </div>
        }
      </div>

      {/* Button to start level. */}
      {page === (maxPages-1) && 
        <button
        onClick={finishTutorial}
          className="tutorial-next-button"
        >
        {tutorialButtonStartLevel}
        </button>
      }

      {/* Button to go to previous page. */}
      {page > 0 && 
        <button
          onClick={handlePrevious}
          className="tutorial-previous-button"
        >
        {tutorialButtonPreviousPage}
        </button>
      }

      {/* Button to go to next page. */}
      {page < (maxPages-1) && 
        <button
          onClick={handleNext}
          className="tutorial-next-button"
        >
        {tutorialButtonNextPage}
        </button>
      }
    </div>
  );
}

export default Tutorial6Binary;
